
<template>

  <Modal @close="closeModale">
    <template #header>
      واریز تومان
    </template>
    <template #body >
      <div class="body">
        <p class="text"> ﺟﻬﺖ اﻓﺰاﯾﺶ اﻋﺘﺒﺎر کیف ﭘﻮل ﺗﻮﻣﺎن ﺧﻮد ﺑﺎ اﺳﺘﻔﺎده از ﮐﺎرت‌ﻫﺎی بانکی ﻋﻀﻮ ﺷﺒﮑﻪ ﺷﺘﺎب و از ﻃﺮﯾﻖ درﮔﺎه ﭘﺮداﺧﺖ،ﺣﺘﻤﺎ ﺑﺎﯾﺪ از ﮐﺎرت‌ﻫﺎی بانکی ﺑﻪ ﻧﺎم ﺧﻮدﺗﺎن ﮐﻪ در ﭘﺮوﻓﺎﯾﻠﺘﺎن ﺗﺎﯿﯾﺪ ﺷﺪه اﺳﺖ اﺳﺘﻔﺎده نمایید.</p>


        <div class="inputs-container">
          <label class="inventory">{{'موجودی' + ' :' + $toLocal(cash,$decimal['TOMAN']) +' '+ 'تومان' }}</label>
          <label-input label=" مبلغ واریزی" @value='
          value=> (amount) = value'

          />
                 <div class="dropdown">
          <div

            @click.prevent="openDropdown = !openDropdown"
            id="openDrop"
          >
            <span> {{ select }}</span>
          </div>
          <label for="openDrop">

          </label>
          <div class="list" v-if="openDropdown">
            <div
              v-for="(Bank,index) in Banks" :key="index"
              @click.prevent="selectItems(index)"
            >
              <p>{{ Bank.cardNumber }}</p>
            </div>
          </div>
        </div>
        </div>
<!--        <div class="addbtn">افزودن کارت</div>-->
        <button  @click="closeModale">ثبت</button>

      </div>
    </template>

  </Modal>

</template>

<script>
import Modal from './Modal'
export default {
  name: 'CryptoWithdarw',
  components:{
    Modal,
  },

  props:{

        relatedCoin: {
      default: "",
    },

    wage: {
      default: 0,
    },
// cash:{
//   default:0
// }

  },
    data() {
    return {
      inventory:[],
      closeIt: true,
      continu: false,
      submit: false,
      success: false,
      select: "",
      coins:[],
      openDropdown: false,
      Banks:[],
      amount:0,
      role:{},
      cash:0


    };
  },

  methods: {
    closeModale() {
      this.$emit("closeModal" , false);

    },
    logOut() {
      this.$logout();
      // this.$router.push('/login')
    },
    selectItems(index) {
      this.select = this.Banks[index].cardNumber;
      this.walletAddress = this.select
      this.openDropdown = false;
    },
    async getInventory(){
      this.state.loading = true;
      let res = await this.$axios('/wallets/customer-addresses?walletType=P2P')
      this.cash = res["TOMAN"].credit

    },
      async getData() {
            this.state.loading = true
            const res = await this.$axios.get('/users/verified-bank-accounts')
            this.Banks = res.content


        },
                async getDataCoins() {
            this.state.loading = true
            const res = await this.$axios.get('/coins/details')
            this.coins = res.content
            this.role = this.coins.find((a) => a.coin === "TOMAN")


        },
        async deposit() {
            this.state.loading = true
            let walletInfo = {
                amount: this.$S2N(this.amount),
                paymentGateway: 'ZARRINPAL',
                cardNumber: this.walletAddress,
                callBackURL: this.$callBackURL
            }

            const res = await this.$axios.post('/wallets/deposit-toman', walletInfo)

            if (res.message === "Deposit Request Created Successfully") {
                this.$emit('close');
                window.open(res.baseDTO.redirectSite, "_self")
            }
        },
  },
   async mounted() {
   this.getDataCoins()
    this.getInventory()
   await this.getData()
    this.select = this.Banks[0].cardNumber
    this.walletAddress = this.select

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss'scoped>
.inputs-container{
display: flex;
flex-direction: column;
position: relative;
}
.list{
  display: flex;
  flex-direction: column;
  // gap:10px;
  position: absolute;
  top: 150px;
  width: 100%;
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
    box-shadow: 0px 4px 24px -1px rgb(0 0 0 / 25%);
    left:0;
    right:0;
}
.dropdown{
  border: 1px solid #D7C8C8;
    box-sizing: border-box;
    border-radius: 4px;
    height: 52px;
    display: flex;
    align-items: center;
    padding: 10px;
}

.inventory{
  font-size:clamp(10px,1vw,12px);
  display: flex;
  align-items: center;
}
.inputs-container{
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-top:40px;
}


button{
  background: linear-gradient(181.54deg, #1199FA 1.31%, #123249 180.79%);
  border-radius: 4px;
  width: 100%;
  margin-top: 40px;
  color: white;
  padding: 8px 0;
}
.addbtn{
  margin-top: 25px;
  text-align: center;
  color: #1199FA;
  font-size: clamp(14px,1.5vw,16px);
}
.body{
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}
.inputs-container{
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}

.text{
  font-size: clamp(13px,1.4vw,16px);
  margin-top: 40px;
}
</style>
